module.exports = __webpack_public_path__ + "static/media/Menu.6822d389.svg";